// extracted by mini-css-extract-plugin
export default {"GitHubAvatar":"use-assignees-editor-module__GitHubAvatar--h1AYh"};